import { Form } from "antd";

import { Banner } from "@/ui-components/commonComponents/Banner/Banner";
import { SubmitButton } from "@/ui-components/commonComponents/Button/SubmitButton";
import EmailChipsInput, { EmailChipsInputRef } from "@/ui-components/commonComponents/EmailChipsInput/EmailChipsInput";

import style from "./style.module.css";
import { useRef } from "react";

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

export function AddCandidateForm({
  title,
  formName,
  isLoading = false,
  onSubmit,
  inputProps,
  disabled = false,
  buttonProps,
}: {
  title: string;
  formName: string;
  isLoading?: boolean;
  disabled?: boolean;
  onSubmit: (value: { candidatesData: string[] }) => void;
  inputProps: {
    name: string;
    label: string;
    errorText: string;
    required: boolean;
  }[];
  buttonProps: {
    title: string;
  };
}) {
  const [form] = Form.useForm();
  const emailChipsRef = useRef<EmailChipsInputRef>(null);

  return (
    <div className={style.background}>
      <div className={style.mainContainer}>
        <div className={style.innerContainer}>
          <Banner title={title} />

          <div className={style.instructions}>
            <p>Enter one or more candidate emails.</p>
            <p>
              📌 <strong>Tip:</strong> You can separate emails with a comma or a line break (return), or simply copy and
              paste from an excel file.
            </p>
          </div>

          <Form form={form} name={formName} {...formItemLayout} onFinish={onSubmit} requiredMark={false}>
            {inputProps.map(({ name, label, required, errorText }) => (
              <Form.Item
                className={style.inputTitle}
                key={name}
                name={name}
                label={label}
                initialValue={[]}
                rules={[
                  {
                    required: required,
                    message: errorText,
                  },
                  () => ({
                    validator: () => {
                      if (emailChipsRef.current?.hasUnhandledDanglingEmailText()) {
                        return Promise.reject(new Error("Please complete or remove the invalid email address"));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <EmailChipsInput ref={emailChipsRef} />
              </Form.Item>
            ))}

            <div className={style.buttonContainer}>
              <SubmitButton isLoading={isLoading} disabled={disabled}>
                {buttonProps.title}
              </SubmitButton>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}
